import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdatePaymentMethodForm from "../../forms/CreateOrUpdatePaymentMethodForm";
import { PaymentMethodResponseDto } from "../../shared/dtos/paymentMethod/PaymentMethodResponseDto";

interface UpdatePaymentMethodModalProps {
  open: boolean;
  onClose: () => void;
  method: PaymentMethodResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdatePaymentMethodModal: React.FC<UpdatePaymentMethodModalProps> = ({
  open,
  onClose,
  method,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${method.name}`}
    width="md"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdatePaymentMethodForm
      isEditing={true}
      paymentMethod={method}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdatePaymentMethodModal;
